import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaddingVertical12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPaddingVertical12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.002 1.5a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1 0-1h9.002a.5.5 0 0 1 .5.5M4.546 5.045v1.907a.5.5 0 0 0 .5.5h1.91a.5.5 0 0 0 .5-.5V5.045a.5.5 0 0 0-.5-.5h-1.91a.5.5 0 0 0-.5.5m-1 .954v-.954a1.5 1.5 0 0 1 1.5-1.5h1.91a1.5 1.5 0 0 1 1.5 1.5v1.907a1.5 1.5 0 0 1-1.5 1.5h-1.91a1.5 1.5 0 0 1-1.5-1.5zM10.5 11a.5.5 0 1 0 0-1h-9a.5.5 0 1 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaddingVertical12);
